import { render, staticRenderFns } from "./FloorArea.vue?vue&type=template&id=c69a1a54&"
import script from "./FloorArea.vue?vue&type=script&lang=ts&"
export * from "./FloorArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports